import type { AxiosInstance } from 'axios'
import type { IFactoryFunctionRequest, IFactoryResponse, IInvoicingInformation } from '@bc-library/interface'
import { EMethod } from '@bc-library/interface'
import useAxios from '@/services/api/useAxios'
import { API_MAIN_VERSION, BASE_URL } from '@/config/constantes'

const resource = 'projectCommissionCategorys'

const getFilter = (axios: IFactoryFunctionRequest<any, any>) => (query?: { optionalFields: string[] }): IFactoryResponse<Array<IInvoicingInformation>, undefined> => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/firm/filter`,
    query,
  })
}

const filter = (axios: IFactoryFunctionRequest<Array<Pick<IOffice, '_id' | 'display'>>, undefined>) => ({
  page = 0,
  display = '',
  limit = 30,
}: { page?: number; display?: string; limit?: number }) => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/filter`,
    query: { page, display, limit },
  })
}

const getProjectCommissionCategories = (axios: IFactoryFunctionRequest<any, any>) => () => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2`,
  })
}

const getOne = (axios: IFactoryFunctionRequest<any, any>) => (id: string) => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/${id}`,
  })
}
const getDefault = (axios: IFactoryFunctionRequest<any, any>) => () => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/default`,
  })
}

const createProjectCommissionCategory = (axios: IFactoryFunctionRequest<any, any>) => (data: any) => {
  return axios({
    method: EMethod.post,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2`,
    data,
  })
}

const updateProjectCommissionCategory = (axios: IFactoryFunctionRequest<any, any>) => (id: string, { data }: { data: any }) => {
  return axios({
    method: EMethod.put,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/${id}`,
    data,
  })
}

const deleteProjectCommissionCategory = (axios: IFactoryFunctionRequest<any, any>) => (id: string) => {
  return axios({
    method: EMethod.delete,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/${id}`,
  })
}

export default (axios: AxiosInstance) => ({
  getFilter: getFilter(useAxios(axios)),
  filter: filter(useAxios(axios)),
  getProjectCommissionCategories: getProjectCommissionCategories(useAxios(axios)),
  getOne: getOne(useAxios(axios)),
  getDefault: getDefault(useAxios(axios)),
  create: createProjectCommissionCategory(useAxios(axios)),
  update: updateProjectCommissionCategory(useAxios(axios)),
  delete: deleteProjectCommissionCategory(useAxios(axios)),
})
